import { p as o } from "../../styled-components.browser.esm-DBaC0ZEI.mjs";
const t = o("div")`
  --ag-header-background-color: var(--gray-2) !important;
  --ag-font-family: inherit !important;
  --ag-header-foreground-color: var(--primary-10) !important;
  --ag-header-cell-hover-background-color: none !important;
  --ag-foreground-color: var(--gray-9) !important;
  --ag-background-color: var(--gray-1) !important;
  --ag-selected-row-background-color: transparent !important;
  --ag-alpine-active-color: var(--primary-7) !important;
  --ag-row-hover-color: var(--gray-2) !important;
  --ag-row-border-color: var(--gray-4) !important;
  --ag-selected-row-background-color: rgba(239, 219, 255, 0.6) !important;
  --ag-border-radius: var(--br-1) !important;
  --ag-border: 1px solid var(--gray-2) !important;

  .gf-group-header-center {
    .ag-header-group-cell-label {
      justify-content: center !important;
    }
  }

  .column-sort-header {
    padding: var(--space-4) !important;
  }

  .ag-root-wrapper {
    border: 0;
    border-top-left-radius: var(--br-3) !important;
    border-top-right-radius: var(--br-3) !important;
  }

  ${({
  actionbuttons: r
}) => r && `
    .ag-pinned-right-header, .ag-horizontal-right-spacer {
      width: 0 !important;
      min-width: 0 !important;
    }
    .ag-pinned-right-cols-container {
      position: absolute !important;
      right: 0;
      pointer-events: none;
    }
    .ag-pinned-right-cols-container * {
      pointer-events: initial;
    }
    .ag-pinned-right-cols-container .ag-cell {
      border: none !important;
    }
    .ag-pinned-right-cols-container .ag-row:not(.ag-row-hover),
    .ag-pinned-right-cols-container .ag-row:not(.ag-row-hover) .ag-cell {
      width: 0 !important;
      padding: 0 !important;
    }
  `}
  ${({
  actionbuttonswithq: r
}) => r && ` 
   .ag-pinned-right-header, .ag-horizontal-right-spacer {
     width: 40px !important;
      min-width:40px !important;
    }
    .ag-pinned-right-cols-container {
      position: absolute !important;
      right: 0;
      pointer-events: none;
    }
    .ag-pinned-right-cols-container * {
      pointer-events: initial;
    }
    .ag-pinned-right-cols-container .ag-cell {
      border: none !important;
    }
    .ag-pinned-right-cols-container .ag-row:not(.ag-row-hover),
    .ag-pinned-right-cols-container .ag-row:not(.ag-row-hover) .ag-cell {
      width: 0 !important;
      padding: 0 !important;
    }
  `}

  ${({
  autoheight: r
}) => r && `
    .ag-center-cols-viewport {
      min-height: var(--tableMinHeight);
    }
  `}

  ${({
  selection: r
}) => r && `
    .ag-root-wrapper {
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
    }
  `}

  ${({
  mask: r
}) => r && `
    .ag-header-cell-resize {
      pointer-events: none;
      opacity: 0.4;
    }
  `}
`;
export {
  t as default
};
//# sourceMappingURL=style.js.map
